module.exports = __webpack_public_path__ + "static/media/26UNRWA25.ae07000b.jpg";